export const CONDITIONAL_INSIGHTS = {
  "13::3": {
    titleKey: "Quiz_Insight_13_3_Title",
    textKey: "Quiz_Insight_13_3_Text",
  },
  "13::2": {
    titleKey: "Quiz_Insight_13_2_Title",
    textKey: "Quiz_Insight_13_2_Text",
  },
  "19::4": {
    titleKey: "Quiz_Insight_19_4_Title",
    textKey: "Quiz_Insight_19_4_Text",
  },
  "19::3": {
    titleKey: "Quiz_Insight_19_3_Title",
    textKey: "Quiz_Insight_19_3_Text",
  },
  "22::Burnt-Out": {
    titleKey: "Quiz_Insight_22_Burnt_Out_Title",
    textKey: "Quiz_Insight_22_Burnt_Out_Text",
  },
  "20::Yes": {
    titleKey: "Quiz_Insight_20_Yes_Title",
    textKey: "Quiz_Insight_20_Yes_Text",
  },
  "21::Yes": {
    titleKey: "Quiz_Insight_21_Yes_Title",
    textKey: "Quiz_Insight_21_Yes_Text",
  },
  "27::Hair-Loss": {
    titleKey: "Quiz_Insight_27_Hair_Loss_Title",
    textKey: "Quiz_Insight_27_Hair_Loss_Text",
  },
  "26::Ageing-Skin": {
    titleKey: "Quiz_Insight_26_Ageing_Skin_Title",
    textKey: "Quiz_Insight_26_Ageing_Skin_Text",
  },
  "24::Stomach-Pain": {
    titleKey: "Quiz_Insight_24_Stomach_Pain_Title",
    textKey: "Quiz_Insight_24_Stomach_Pain_Text",
  },
  "24::Slow-Digestion": {
    titleKey: "Quiz_Insight_24_Slow_Digestion_Title",
    textKey: "Quiz_Insight_24_Slow_Digestion_Text",
  },
  "15::Yes": {
    titleKey: "Quiz_Insight_15_Yes_Title",
    textKey: "Quiz_Insight_15_Yes_Text",
  },
  "50::3": {
    titleKey: "Quiz_Insight_50_3_Title",
    textKey: "Quiz_Insight_50_3_Text",
  },
  "47::2": {
    titleKey: "Quiz_Insight_47_2_Title",
    textKey: "Quiz_Insight_47_2_Text",
  },
  "47::3": {
    titleKey: "Quiz_Insight_47_3_Title",
    textKey: "Quiz_Insight_47_3_Text",
  },
  "44::5": {
    titleKey: "Quiz_Insight_44_5_Title",
    textKey: "Quiz_Insight_44_5_Text",
  },
  "44::4": {
    titleKey: "Quiz_Insight_44_4_Title",
    textKey: "Quiz_Insight_44_4_Text",
  },
  "35::Fragile-Bones": {
    titleKey: "Quiz_Insight_35_Fragile_Bones_Title",
    textKey: "Quiz_Insight_35_Fragile_Bones_Text",
  },
  "25::Yes": {
    titleKey: "Quiz_Insight_25_Yes_Title",
    textKey: "Quiz_Insight_25_Yes_Text",
  },
  "23::3": {
    titleKey: "Quiz_Insight_23_3_Title",
    textKey: "Quiz_Insight_23_3_Text",
  },
  "32::1": {
    titleKey: "Quiz_Insight_32_1_Title",
    textKey: "Quiz_Insight_32_1_Text",
  },
  "48::3": {
    titleKey: "Quiz_Insight_48_3_Title",
    textKey: "Quiz_Insight_48_3_Text",
  },
  "48::2": {
    titleKey: "Quiz_Insight_48_2_Title",
    textKey: "Quiz_Insight_48_2_Text",
  },
};

export function getInsightForSlide(slideCode, slideValues) {
  if (!slideValues || !slideCode) return null;
  const slideData = slideValues[slideCode];
  if (!slideData) return null;

  for (const key of Object.keys(slideData)) {
    const val = slideData[key]?.value;
    if (val == null) continue;
    const insight = CONDITIONAL_INSIGHTS[`${slideCode}::${val}`];
    if (insight) return insight;
  }
  return null;
}
